<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">绑定记录查询</h2>
      </div>
      <div class="life-filter">
        <el-input v-model="filters.plateNo" placeholder="码牌编号" clearable style="width: 180px" @keyup.enter.native="search" />
        <el-select v-model="filters.communityId" placeholder="小区" clearable filterable style="width: 180px">
          <el-option v-for="c in communityOptions" :key="c.communityId" :label="c.name" :value="c.communityId" />
        </el-select>
        <el-select v-model="filters.state" placeholder="状态" clearable style="width: 110px">
          <el-option label="生效" value="ACTIVE" />
          <el-option label="失效" value="INACTIVE" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">绑定列表</h2>
      </div>
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="plateNo" label="码牌编号" width="150" />
        <el-table-column prop="communityName" label="小区" width="150" />
        <el-table-column label="场景" width="150" align="center">
          <template slot-scope="scope">{{ sceneName(scope.row.sceneCode) }}</template>
        </el-table-column>
        <el-table-column prop="displayName" label="展示名称" min-width="150" />
        <el-table-column prop="installLocation" label="安装位置" min-width="150" />
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.state === 'ACTIVE' ? 'success' : 'info'" size="small">
              {{ scope.row.state === 'ACTIVE' ? '生效' : '失效' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="effectiveAt" label="生效时间" width="170" />
        <el-table-column prop="expiredAt" label="失效时间" width="170" />
      </el-table>
      <el-pagination class="life-pagination" :current-page.sync="page.current" :page-size="page.size"
        :page-sizes="[10, 20, 50]" :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize" @current-change="load" />
    </section>
  </div>
</template>

<script>
import { listBindings } from '@/api/aggregateCode/aggregateCodeApi'
import { getMyEnteredCommunitys, getDict } from '@/api/community/communityApi'

export default {
  name: 'AggregateCodeBindingList',
  data() {
    return {
      loading: false, rows: [], communityOptions: [], sceneOptions: [],
      filters: { plateNo: '', communityId: '', state: '' },
      page: { current: 1, size: 10, total: 0 }
    }
  },
  created() { this.load(); this.loadCommunities(); this.loadSceneDict() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listBindings({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = Number(res.total || 0)
      } catch (error) {
        this.$message.error(error.message || '加载绑定记录失败')
      } finally { this.loading = false }
    },
    async loadCommunities() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 200 })
        this.communityOptions = res.communitys || res.data || []
      } catch (_) { /* ignore */ }
    },
    async loadSceneDict() {
      try { this.sceneOptions = await getDict('aggregate_code_binding', 'scene_code') || [] } catch (_) { /* ignore */ }
    },
    sceneName(code) {
      const s = this.sceneOptions.find(o => o.name === code)
      return s ? (s.description || s.name) : code
    },
    search() { this.page.current = 1; this.load() },
    reset() { this.filters = { plateNo: '', communityId: '', state: '' }; this.search() },
    changeSize(size) { this.page.size = size; this.load() }
  }
}
</script>

<style lang="scss" scoped>
@import './life.scss';
</style>
